// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"f459ddbc","239":"2f822dd7","484":"7e6519f4","508":"1d15611f","629":"ca25c63a","869":"0d4c4745","932":"2d90040a","974":"e4c47237"}[chunkId] + ".chunk.js";
};